import { useCallback } from 'react';
import { useInfiniteResource } from 'hooks/useInfiniteResource';
import salesforceAccountsService from 'services/salesforceAccountsService';

const INTERACTIONS_PER_PAGE = 10;

const useAccountInteractions = (accountId) => {
	const fetchFn = useCallback(
		async (page) => {
			if (!accountId) return { data: [], totalCount: 0 };
			const response = await salesforceAccountsService.getInteractions(
				accountId,
				page,
				INTERACTIONS_PER_PAGE
			);
			return {
				data: response?.interactions || [],
				totalCount: response?.total || 0,
			};
		},
		[accountId]
	);

	const { data, totalCount, loading, loadingMore, error, hasMore, loadMore } =
		useInfiniteResource({ fetchFn });

	return {
		interactions: data,
		totalCount,
		loading,
		loadingMore,
		error,
		hasMore,
		loadMore,
	};
};

export default useAccountInteractions;
